module.exports = __webpack_public_path__ + "img/IND-B-2-III.5c45bafc.png";